<script setup lang="ts">
/**
 * Breadcrumb — top-of-content path indicator.
 *
 * Reads the current route's `meta.crumb` (e.g. "Content · VOD") and
 * splits on the legacy " · " separator to render with text-3 dim
 * styling on intermediate segments and text-1 on the leaf.
 *
 * Matches the prototype's #crumb-group span behaviour.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const segments = computed(() => {
  const crumb = (route.meta.crumb as string | undefined) ?? ''
  if (!crumb) return []
  return crumb.split(' · ').map((s) => s.trim()).filter(Boolean)
})
</script>

<template>
  <nav
    v-if="segments.length"
    class="flex items-center gap-1.5 text-xs text-text-3"
    aria-label="breadcrumb"
  >
    <template v-for="(seg, i) in segments" :key="i">
      <span
        :class="i === segments.length - 1 ? 'text-text-1 font-medium' : ''"
      >{{ seg }}</span>
      <span
        v-if="i < segments.length - 1"
        class="text-text-5"
        aria-hidden="true"
      >·</span>
    </template>
  </nav>
</template>
